import { useState, useEffect, useContext } from "react";
import PointApi from "../../../api/PointApi";
import PageNavigation from "../../pageNavigation/PageNavigation";
import UserContext from "../../../context/UserContext";
import { formatDateYYYMMDD } from "../../../util/dateUtil";

const formatPointDateLabel = (date) => {
    const formatted = formatDateYYYMMDD(date);
    return formatted ? formatted.replace(/-/g, ".") : "";
};

const formatPointAmount = (point) => {
    const value = Number(point) || 0;
    return `${value.toLocaleString()}P`;
};

const getPointDisplay = (item) => {
    const isPlus = item.type === "C" || item.type === "R";
    const amount = Number(item.amount) || 0;
    const absAmount = Math.abs(amount);

    let badgeLabel = "사용";
    if (item.type === "C") badgeLabel = "적립";
    else if (item.type === "R") badgeLabel = "환불";

    let title = badgeLabel;
    if (item.type === "C") title = "포인트 충전";
    else if (item.type === "R") title = "포인트 환불";

    return {
        badgeLabel,
        badgeClass: isPlus ? "point-history-badge--plus" : "point-history-badge--minus",
        amountClass: isPlus ? "point-history-amount--plus" : "point-history-amount--minus",
        amountLabel: `${isPlus ? "+" : "-"}${absAmount.toLocaleString()}P`,
        title,
        description: item.description || null,
    };
};

const MyPoint = () => {
    const { user } = useContext(UserContext);
    const [totalCnt, setTotalCnt] = useState(0);
    const [pointHistory, setPointHistory] = useState([]);

    const handlePageChg = async (page) => {
        const res = await PointApi.getPointHistory(page);
        setPointHistory(res);
    };

    useEffect(() => {
        PointApi.getPointHistory(1, true).then((res) => {
            setTotalCnt(res.totalCnt);
        });
    }, []);

    return (
        <section className="mypage-container">
            <section className="point-history">
                <div className="point-history-summary">
                    <strong>포인트</strong>
                    <span>{formatPointAmount(user?.point)}</span>
                    {/* <em>
                        일주일 내 소멸 예정 <b>24P</b>
                    </em> */}
                </div>

                <div className="point-history-list">
                    {pointHistory.map((item, index) => {
                        const display = getPointDisplay(item);
                        return (
                            <article
                                key={`${item.date}_${item.amount}_${index}`}
                                className="point-history-item"
                            >
                                <time className="point-history-date">
                                    {formatPointDateLabel(item.date)}
                                </time>

                                <span className={`point-history-badge ${display.badgeClass}`}>
                                    {display.badgeLabel}
                                </span>

                                <div className="point-history-content">
                                    <h3>{display.title}</h3>
                                    {display.description && <p>{display.description}</p>}
                                </div>

                                <strong
                                    className={`point-history-amount ${display.amountClass}`}
                                >
                                    {display.amountLabel}
                                </strong>
                            </article>
                        );
                    })}
                </div>

                <PageNavigation
                    totalCount={totalCnt}
                    showCount={30}
                    onChange={handlePageChg}
                />
            </section>
        </section>
    );
};

export default MyPoint;
